import styled, { css } from "styled-components";
import { white, narrowScreenMediaQuery } from "../constants/styles";
import { FooterTheme } from "./theme_color";
import Section, { SectionSeparator } from "./Section";
import ExternalLink from "./ExternalLink";
import { unmodule } from "../util";

const UnnamedComponent = (props) => {
  return (
    <FooterTheme>
      <SectionSeparator />
      <Section $paddingY>
        <LogoDiv>
          <img
            src={unmodule(require("../images/new_logo_tlc_white.png"))}
            alt="logo tlc"
          />
        </LogoDiv>
        <Flex>
          <div>
            <InfoTitle>Office Location</InfoTitle>
            <InfoDesc>
              Sudirman Park Commercial Area - (C12, B5, B8)
              <br />
              Jl. KH. Mas Mansyur No. 12 Central Jakarta City,
              <br />
              Jakarta 10250
            </InfoDesc>
            <CertifiedBy>
              Certified By :
              <div>
                <img
                  src={unmodule(
                    require("../images/tlc-certified-by-aptika.png"),
                  )}
                  alt="tlc certified by ditjen tata kelola aptika"
                />
              </div>
            </CertifiedBy>
          </div>
          <div>
            <InfoTitle>About Us</InfoTitle>
            <InfoDesc>
              <MenuLink to="/faq">FAQ</MenuLink>
              <MenuLink to="https://taxsam.co">Taxsam.co</MenuLink>
              <MenuLink to="https://learning.taxsam.co">
                Taxsam Learning Center
              </MenuLink>
              <MenuLink to="https://taxbase.taxsam.co/insight-explore">
                Berita &amp; Artikel
              </MenuLink>
              <MenuLink to="https://taxbase.taxsam.co/insight-explore">
                Career at Taxsam.co
              </MenuLink>
            </InfoDesc>
          </div>
          <div>
            <InfoTitle>Navigation</InfoTitle>
            <InfoDesc>
              <MenuLink to="/talks">Taxsam Talk</MenuLink>
              <MenuLink to="/courses">Video Belajar Pajak</MenuLink>
              <MenuLink to="https://taxbase.taxsam.co/library/workbook">
                Perpustakaan
              </MenuLink>
              <MenuLink to="https://taxbase.taxsam.co">
                Database Perpajakan
              </MenuLink>
              <MenuLink to="/affiliators">Affiliate Program</MenuLink>
            </InfoDesc>
          </div>
          <div>
            <InfoTitle>Social Media</InfoTitle>
            <Socials>
              <MenuLink to="https://www.facebook.com/taxsam.co">
                <img
                  src={unmodule(require("../images/icons/facebook.svg"))}
                  alt="facebook"
                />
              </MenuLink>
              <MenuLink to="https://linkedin.com/company/taxsam-co">
                <img
                  src={unmodule(require("../images/icons/linkedin.svg"))}
                  alt="linkedin"
                />
              </MenuLink>
              <MenuLink to="https://www.instagram.com/taxsam_co/">
                <img
                  src={unmodule(require("../images/icons/instagram.svg"))}
                  alt="instagram"
                />
              </MenuLink>
              <MenuLink to="https://www.youtube.com/@TAXSAMCO">
                <img
                  src={unmodule(require("../images/icons/youtube.svg"))}
                  alt="youtube"
                />
              </MenuLink>
            </Socials>
            <Whatsapp>
              <MenuLink to="https://wa.me/+6282124457963">
                <img
                  src={unmodule(require("../images/chat-on-whatsapp.png"))}
                  alt="whatsapp"
                />
              </MenuLink>
            </Whatsapp>
          </div>
        </Flex>
        <Copyrights>© 2023 TAXSAM.CO. ALL RIGHTS RESERVED</Copyrights>
      </Section>
    </FooterTheme>
  );
};
export default UnnamedComponent;

const Whatsapp = styled.div`
  margin-top: 10px;

  & img {
    width: 158px;
  }
`;

const Socials = styled.div`
  display: flex;
  gap: 10px;

  & img {
    width: 32px;
  }
`;

const MenuLink = styled(ExternalLink)`
  color: ${white};
  display: block;
  text-decoration: unset;
`;

const CertifiedBy = styled.div`
  font-weight: bold;
  margin-top: 30px;

  & img {
    margin-top: 10px;
    width: 200px;
  }
`;

const InfoDesc = styled.div`
  line-height: 2;
`;

const InfoTitle = styled.div`
  font-weight: bold;
  margin-bottom: 30px;
`;

const cssCommonNarrow = css`
  @media ${narrowScreenMediaQuery} {
    flex-direction: column;
    margin-left: auto;
    margin-right: auto;
    width: 305px;
  }
`;

const LogoDiv = styled.div`
  ${cssCommonNarrow};

  & > img {
    max-width: 250px;
  }
`;

const Flex = styled.div`
  ${cssCommonNarrow};
  align-items: start;
  display: flex;
  gap: 20px;
  justify-content: space-between;
  margin-top: 30px;
`;

const Copyrights = styled.div`
  ${cssCommonNarrow};
  margin-top: 50px;
`;
